import moment from 'moment';
import FormTableControl from 'components/shared/FormTable/FormTableControl';
import styles from './GA2RFControllerTable.module.css';

const azElRange = { min: -45, max: 45 };

const validateIntegerInRange = (value, errorMsg) => {
  if (value === '') {
    return true;
  }

  const integerRegex = /^-?\d+$/; // Regular expression to accept positive and negative integers
  if (!integerRegex.test(value)) {
    return 'Value must be a valid integer.';
  }

  const intValue = parseInt(value);

  if (Number.isNaN(intValue) || intValue < azElRange.min || intValue > azElRange.max) {
    return errorMsg;
  }

  return true;
};

export const parameters = [
  {
    name: 'azElectrical',
    label: 'Azimuth - Electrical',
    hoverMessage: 'Twin reported azimuth direction of the selected HBF beam',
    range: azElRange,
    disabled: false,
    option: {
      required: false,
      validate: (value) => validateIntegerInRange(value, 'Azimuth must be either 361 or in the range of -45 and 45.')
    }
  },
  {
    name: 'dtElectrical',
    label: 'Downtilt - Electrical',
    hoverMessage: 'Twin reported downtilt direction of the selected HBF beam (downtilt = -elevation)',
    range: azElRange,
    disabled: false,
    option: {
      required: false,
      validate: (value) => validateIntegerInRange(value, 'Downtilt must be either -361 or in the range of -45 and 45.')
    }
  }
];

export const columns = [
  {
    id: 'label',
    accessor: (item) => item.label,
    Header: 'Parameter',
    Cell: ({ original, value }) => (
      <div className={styles.cellDiv} data-tip={original.hoverMessage}>
        {value}
      </div>
    ),
    minWidth: 125
  },
  {
    id: 'range',
    accessor: (item) => `${item.range.min}/${item.range.max}`,
    Header: 'Min/Max',
    className: styles.cell,
    minWidth: 92
  },
  {
    id: 'value',
    accessor: (item) => item.value,
    Header: 'Current Value',
    className: styles.cell,
    minWidth: 90,
    sortable: false
  },
  {
    id: 'input',
    Header: 'New Value',
    Cell: ({ original }) =>
      original.hidden ? null : (
        <FormTableControl name={original.name} disabled={original.disabled} option={original.option} />
      ),
    className: styles.cell,
    minWidth: 110,
    sortable: false
  },
  {
    id: 'updatedTime',
    accessor: (parameter) => (parameter.lastUpdated ? new Date(parameter.lastUpdated) : null),
    Header: 'Last Updated',
    Cell: ({ value }) => {
      const displayValue = value ? moment(value).format('MMM DD, YYYY h:mm a') : null;
      return (
        <div className={styles.cellDiv} data-tip={displayValue}>
          {displayValue}
        </div>
      );
    },
    minWidth: 120
  }
];
